<template>
  <l-layout layout="['xs12']">
    <v-card>
      <v-form ref="sendConfigForm">
      </v-form>
    </v-card>
  </l-layout>
</template>

<script>
export default {
  name: 'newSendConfig'
}
</script>

<style scoped>

</style>
